import React, { Fragment, useState, useEffect } from "react";
import { Grid, Card, Typography, Button, Box } from "@mui/material";
import moment from "moment";

import { getCandidateAlert } from "../../apis/AlertGeneration";

// import { CBEWSL_SITE, CBEWSL_SITE_CODE, CBEWSL_SITE_NAME } from "../../host";
import Analysis from "./Analysis";
import PLGUAnalysis from "./PLGUAnalysis";

const CBEWSL_SITE = "sum";
const alert_level_colors = [
  { alert_level: 0, color: "#c5e0b4" },
  { alert_level: 1, color: "#FCEE27" },
  { alert_level: 2, color: "#F8991D" },
  { alert_level: 3, color: "#e11e1ec9" },
];

function HeaderAlertInformation(props) {
  const { onGoingData, routineData, ewiTemplates } = props;
  const [alert_level, setAlertLevel] = useState(0);
  const [data_timestamp, setDataTimestamp] = useState(moment().format("LLL"));
  const [latest_triggers, setLatestTriggers] = useState([]);
  const [responses, setResponses] = useState({
    barangay_response: "",
    commmunity_response: "",
    munisipyo_response: "",
  });
  const [validity, setValidity] = useState(null);

  useEffect(() => {
    if (onGoingData.length > 0) {
      const {
        highest_event_alert_level,
        latest_event_triggers,
        public_alert_symbol,
      } = onGoingData[0];
      const template = ewiTemplates.find(
        (e) => e.alert_level === public_alert_symbol.alert_level
      );
      setAlertLevel(public_alert_symbol.alert_level);
      setResponses(template);
      const triggers = latest_event_triggers.map((row, index) => {
        const { internal_sym, trigger_misc } = row;
        const { trigger_symbol } = internal_sym;
        const { trigger_hierarchy, alert_level } = trigger_symbol;
        const { trigger_source } = trigger_hierarchy;
        let template = ewiTemplates.find(
          (e) => e.trigger === trigger_source && e.alert_level === alert_level
        );
        if (trigger_source === "on demand") {
          const { on_demand } = trigger_misc;
          const { eq_id } = on_demand;
          if (eq_id) {
            template = ewiTemplates.find(
              (e) => e.alert_level === alert_level && e.trigger === "earthquake"
            );
          } else {
            template = ewiTemplates.find(
              (e) => e.alert_level === alert_level && e.trigger === "rainfall"
            );
          }
        }
        if (template) {
          return template;
        }
      });

      setLatestTriggers(triggers);
    } else {
      if (ewiTemplates.length > 0) {
        const template = ewiTemplates.find((e) => e.alert_level === 0);
        setResponses(template);
        setLatestTriggers([template]);
        setAlertLevel(0);
      }
      // setValidity(`valid until ${moment().format("LLL")}`)
    }
  }, [onGoingData]);
  return (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      textAlign={"center"}
    >
      <Grid
        item
        xs={12}
        style={{
          width: "100%",
          margin: 50,
        }}
      >
        <Card
          style={{
            padding: 10,
            backgroundColor: alert_level_colors.find(
              (e) => e.alert_level === alert_level
            ).color,
            borderTopLeftRadius: 60,
            borderTopRightRadius: 0,
          }}
        >
          <Grid container spacing={1}>
            <Grid
              item
              xs={3}
              style={{ alignSelf: "center", maxHeight: "200px" }}
            >
              <Typography variant="h5">
                Purok 1, 2, 3, Brgy. Magsaysay,
              </Typography>
              <Typography variant="h5">Kibawe, Bukidnon</Typography>
              <Typography variant="h3">
                <b>ALERT LEVEL {alert_level}</b>
              </Typography>
              <Typography variant="h5">
                {moment(data_timestamp).format("MMMM D, YYYY, h:mm A")}
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}
              overflow={"auto"}
              style={{
                alignSelf: "center",
                borderLeft: "solid 2px rgba(0, 0, 0, 0.5)",
                marginTop: 8,
                padding: 25,
                maxHeight: "350px",
              }}
            >
              <Typography variant="h6" gutterBottom align="left">
                <strong>
                  Description:{" "}
                  {latest_triggers.length > 0 &&
                    latest_triggers.map((row, index) => {
                      if (row) {
                        const { sms_trigger_description } = row;
                        return `${sms_trigger_description} `;
                      }
                      return "";
                    })}
                  <br />
                  {validity && validity}
                </strong>
              </Typography>
              <br />
              <Typography variant="h6" gutterBottom align="left">
                <strong> Recommended Responses:</strong>
              </Typography>
              <Grid style={{ paddingLeft: 20 }}>
                <Typography
                  variant="body1"
                  gutterBottom
                  align="left"
                  marginBottom={1.5}
                  marginTop={1.5}
                >
                  <strong>Komunidad:</strong>{" "}
                  {responses.sms_community_response
                    ? responses.sms_community_response
                    : "N/A"}
                </Typography>

                <Typography
                  variant="body1"
                  gutterBottom
                  align="left"
                  marginBottom={1.5}
                >
                  <strong>LEWC:</strong>{" "}
                  {responses.sms_lewc_response
                    ? responses.sms_lewc_response
                    : "N/A"}
                </Typography>

                <Typography
                  variant="body1"
                  gutterBottom
                  align="left"
                  marginBottom={1.5}
                >
                  <strong>BLGU:</strong>{" "}
                  {responses.sms_barangay_response
                    ? responses.sms_barangay_response
                    : "N/A"}
                </Typography>

                <Typography
                  variant="body1"
                  gutterBottom
                  align="left"
                  marginBottom={1.5}
                >
                  <strong>MLGU:</strong>{" "}
                  {responses.mlgu_response
                    ? responses.sms_mlgu_response
                    : "N/A"}
                </Typography>

                <Typography
                  variant="body1"
                  gutterBottom
                  align="left"
                  marginBottom={1.5}
                >
                  <strong>PLGU:</strong>{" "}
                  {responses.plgu_response
                    ? responses.sms_plgu_response
                    : "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}

function OpCen2(props) {
  const [expanded, setExpanded] = React.useState(false);

  const [candidate_alerts, setCandidateAlerts] = useState([]);
  const [on_going_alerts, setOnGoingAlerts] = useState([]);
  const [extended_alerts, setExtendedAlerts] = useState([]);
  const [routine, setRoutine] = useState({ released_sites: [] });
  const [cbewsl_ewi_template, setEwiTemplates] = useState([]);
  const [current_user, setCurrentUser] = useState([]);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [selectedAnalysis, setSelectedAnalysis] = useState(null);

  const generateDashboardData = () => {
    getCandidateAlert((data) => {
      const {
        candidate_alerts,
        on_going,
        ewi_templates,
        ground_meas_reminder,
      } = data;

      const temp_candidate = JSON.parse(candidate_alerts);
      const temp_on_going = JSON.parse(on_going);
      const {
        latest,
        overdue,
        extended,
        routine: routine_data,
      } = temp_on_going;
      console.log("temp_on_going", temp_on_going);
      let temp = [];
      temp.push(...latest);
      temp.push(...overdue);
      setOnGoingAlerts(temp);
      if (!routine_data.released_sites) {
        routine_data.released_sites = [];
      }
      setRoutine(routine_data);
      setEwiTemplates(ewi_templates);
      if (routine_data.released_sites) {
        routine_data.released_sites = routine_data.released_sites.filter(
          (e) => e.site_id === parseInt(CBEWSL_SITE)
        );
        setRoutine(routine_data);
      }
      setExtendedAlerts(extended);
      if (extended.length > 0) {
        const extended_site = extended.find((e) => e.event.site.site_id);
        if (extended_site) {
          setCandidateAlerts(
            temp_candidate.filter((e) => e.general_status === "extended")
          );
        }
      } else {
        setCandidateAlerts(temp_candidate);
      }
      setOpenBackdrop(false);
    });
  };

  useEffect(() => {
    setOpenBackdrop(true);
    generateDashboardData();
    const data = localStorage.getItem("mag_credentials");
    setCurrentUser(JSON.parse(data));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      generateDashboardData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  const toggleAnalysis = (type) => {
    setSelectedAnalysis((prev) => (prev === type ? null : type));
  };

  return (
    <Fragment>
      <HeaderAlertInformation
        onGoingData={on_going_alerts}
        routineData={routine}
        ewiTemplates={cbewsl_ewi_template}
      />
      <Box display="flex" justifyContent="center" gap={2} my={3}>
        <Button
          variant={selectedAnalysis === "MAG" ? "outlined" : "contained"}
          onClick={() => toggleAnalysis("MAG")}
        >
          Brgy. Magsaysay, Kibawe
        </Button>
        <Button
          variant={selectedAnalysis === "SUM" ? "outlined" : "contained"}
          onClick={() => toggleAnalysis("SUM")}
        >
          Brgy. Sumalsag, Malitbog
        </Button>
      </Box>

      {selectedAnalysis && (
        <Typography variant="h4" align="center" sx={{ my: 1 }}>
          Data analysis for{" "}
          {selectedAnalysis === "MAG"
            ? "Brgy. Magsaysay, Kibawe"
            : "Brgy. Sumalsag, Malitbog"}
        </Typography>
      )}

      {selectedAnalysis === "MAG" && <Analysis />}
      {selectedAnalysis === "SUM" && <PLGUAnalysis />}
    </Fragment>
  );
}

export default OpCen2;
